document.addEventListener("DOMContentLoaded", () => {
    // 1. Valores base e limites
    const TIME_PER_UNIT = 0.6;
    const MIN_DURATION = 960;
    const MAX_DURATION = 6000;

    // Intervalo de delay sequencial entre cada LI (em milissegundos)
    const STAGGER_DELAY = 300; 

    const animateCounter = (el, delay = 0) => {
        const target = parseFloat(el.getAttribute("data-target"));
        const isDecimal = target % 1 !== 0;

        let duration = target * TIME_PER_UNIT;
        duration = Math.max(MIN_DURATION, Math.min(duration, MAX_DURATION));

        let startTime = null;

        const updateCount = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            
            // Curva Ease-Out Cubic
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = easeProgress * target;

            if (isDecimal) {
                el.innerText = currentValue.toFixed(1);
            } else {
                el.innerText = Math.floor(currentValue);
            }

            if (progress < 1) {
                requestAnimationFrame(updateCount);
            } else {
                el.innerText = target;
            }
        };

        // Aplica o delay de início para cada elemento
        setTimeout(() => {
            // Torna o h3 visível quando a contagem efetivamente começar
            const h3Element = el.closest("h3");
            if (h3Element) {
                h3Element.style.opacity = "1";
            }

            requestAnimationFrame(updateCount);
        }, delay);
    };

    const observerOptions = {
        root: null,
        threshold: 0.3
    };

    const listItems = Array.from(document.querySelectorAll("ul li"));

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const counterSpan = entry.target.querySelector(".counter");
                
                if (counterSpan) {
                    const itemIndex = listItems.indexOf(entry.target);
                    const delay = itemIndex * STAGGER_DELAY;

                    animateCounter(counterSpan, delay);
                }
                
                observerInstance.unobserve(entry.target);
            }
        });
    }, observerOptions);

    listItems.forEach((li) => {
        observer.observe(li);
    });




    const openCloseType01 = document.querySelector('header a.openClose');
    // Seleciona o elemento nav (se for uma tag <nav>. Se for uma div com classe, use '.nav')
    const navMenu = document.querySelector('nav'); 

    if (openCloseType01) {
        openCloseType01.addEventListener('click', function(e) {
            e.preventDefault();
            
            const parent = this.parentElement;
            if (parent) {
                parent.classList.toggle('open');
            }
            
            this.classList.toggle('change');
            
            // Faz o toggle da classe 'mostrar' no elemento nav, caso ele exista na página
            if (navMenu) {
                navMenu.classList.toggle('mostrar');
            }
        });
    }


    // Adiciona o evento de scroll na janela (window)
    window.addEventListener('scroll', () => {
        // Seleciona o cabeçalho
        const header = document.querySelector('header');
        
        // Verifica se o header existe na página para evitar erros
        if (header) {
            // Se o scroll vertical for maior que 50px, adiciona a classe.
            // Se for menor ou igual, ele remove automaticamente.
            if (window.scrollY > 50) {
                header.classList.add('reduzido');
            } else {
                header.classList.remove('reduzido');
            }
            
            // Alternativa mais curta em 1 linha (faz exatamente a mesma coisa que o if/else acima):
            // header.classList.toggle('reduzido', window.scrollY > 50);
        }
    });

    
    // Seleciona o botão (ou link)
    const btnCont = document.querySelector('.btnCont');

    if (btnCont) {
        btnCont.addEventListener('click', function(e) {
            e.preventDefault(); // Previne o comportamento padrão (útil se o botão for uma tag <a>)

            // Calcula a altura total da página
            const alturaTotal = document.documentElement.scrollHeight;

            // Faz o scroll até a altura total com animação suave
            window.scrollTo({
                top: alturaTotal,
                behavior: 'smooth'
            });
        });
    }


     

     const listaUF = document.querySelectorAll('.listUF ul li');
    const containerListUF = document.querySelector('.listUF');
    const mapaInfos = document.querySelector('.mapaInfos');
    const infos = document.querySelectorAll('.mapaInfos .infos .info');
    
    // Novo: Seleciona o elemento do mapa que deve sumir
    const elementoMapa = document.querySelector('.mapaInfos .mapa'); 

    listaUF.forEach((item, index) => {
        item.addEventListener('click', () => {
            
            // Verifica se o item clicado JÁ ESTÁ ativo
            const isActive = item.classList.contains('ativo');

            if (isActive) {
                // ==========================================
                // CASO 1: DESCLICAR (Item já estava aberto)
                // ==========================================
                
                // 1. Remove a marcação de ativo do item
                item.classList.remove('ativo');
                
                // 2. Esconde a .info correspondente
                if (infos[index]) {
                    infos[index].classList.remove('mostrar');
                }
                
                // 3. Mostra o mapa novamente
                if (elementoMapa) {
                    elementoMapa.classList.remove('esconder-mapa');
                }
                
                // 4. Remove a altura forçada do mapaInfos
                if (mapaInfos) {
                    mapaInfos.style.height = ''; 
                }

            } else {
                // ==========================================
                // CASO 2: CLICAR (Item não estava aberto)
                // ==========================================
                
                // 1. Remove a classe 'ativo' de todos os itens e adiciona só no clicado
                listaUF.forEach(li => li.classList.remove('ativo'));
                item.classList.add('ativo');

                // 2. Esconde todas as infos (caso tenha outra aberta)
                infos.forEach(info => info.classList.remove('mostrar'));

                // 3. Esconde o mapa
                if (elementoMapa) {
                    elementoMapa.classList.add('esconder-mapa');
                }

                // 4. Mede a altura e aplica no container principal (permanece igual)
                if (mapaInfos && containerListUF) {
                    const alturaDaLista = containerListUF.offsetHeight;
                    mapaInfos.style.height = alturaDaLista + 'px';
                    mapaInfos.classList.add('mostrar');
                }
                
                // 5. Mostra a .info correspondente de forma suave
                if (infos[index]) {
                    infos[index].classList.add('mostrar');
                }
            }
        });
    });



    // Seleciona todos os links da página cujo atributo href comece com "#"
    const linksSuaves = document.querySelectorAll('a[href^="#"]');

    linksSuaves.forEach(link => {
        link.addEventListener('click', function(e) {
            // Previne o comportamento padrão (o "pulo" seco)
            e.preventDefault();

            // Pega exatamente o valor do href (ex: "#contato")
            const id = this.getAttribute('href');

            // Ignora se o link for apenas "#" sem nenhum ID definido
            if (id === '#') return;

            // Procura o elemento na página que tem esse ID
            const elementoDestino = document.querySelector(id);

            // Se o elemento existir na página, faz o scroll animado
            if (elementoDestino) {
                elementoDestino.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start' // Alinha o elemento no topo da tela
                });
            }
        });
    });



});



const isDesktop = window.innerWidth >= 1025;

if (isDesktop) {

    document.addEventListener('DOMContentLoaded', () => {
        // Seleciona os itens de navegação do desktop e os blocos de conteúdo
        const itensDesktop = document.querySelectorAll('.lista .item');
        const blocosConteudo = document.querySelectorAll('.blocos .bloco');

        itensDesktop.forEach((item, index) => {
            item.addEventListener('click', () => {
                
                // 1. Remove a classe 'current' de todos os itens da lista
                itensDesktop.forEach(el => el.classList.remove('current'));
                
                // 2. Adiciona a classe 'current' APENAS no item clicado
                item.classList.add('current');

                // 3. Remove a classe 'ativo' de todos os blocos (esconde tudo)
                blocosConteudo.forEach(bloco => bloco.classList.remove('ativo'));

                // 4. Adiciona a classe 'ativo' no bloco com o mesmo índice do item clicado
                if (blocosConteudo[index]) {
                    blocosConteudo[index].classList.add('ativo');
                }
            });
        });
    });


} else {
    document.addEventListener("DOMContentLoaded", () => {
    
        // ==========================================
        // 1. LÓGICA DO MENU DROPDOWN E ABAS (BLOCOS)
        // ==========================================
        const navContainer = document.querySelector('.nav');
        const navParagrafo = document.querySelector('.nav p');
        const navSpan = document.querySelector('.nav span');
        const navItens = document.querySelectorAll('.nav .lista .item'); // Itens do menu
        const blocos = document.querySelectorAll('.blocos .bloco');

        // Abre/Fecha o dropdown (SlideToggle)
        if(navSpan) {
            navSpan.addEventListener('click', () => {
                navContainer.classList.toggle('aberta');
            });
        }

        // Clique nos itens do dropdown
        navItens.forEach((item, index) => {
            item.addEventListener('click', () => {
                // A) Substitui o texto do <p>
                navParagrafo.innerHTML = item.innerHTML;
                
                // B) Fecha o dropdown
                navContainer.classList.remove('aberta');
                
                // C) Mostra o bloco correspondente e esconde os outros
                blocos.forEach(bloco => bloco.classList.remove('ativo'));
                if (blocos[index]) {
                    blocos[index].classList.add('ativo');
                }
            });
        });

        // Fecha o dropdown se clicar fora dele
        document.addEventListener('click', (evento) => {
            if (navContainer && !navContainer.contains(evento.target)) {
                navContainer.classList.remove('aberta');
            }
        });

        // ==========================================
        // 2. LÓGICA DA SANFONA DENTRO DOS BLOCOS
        // ==========================================
        // Seleciona APENAS os h3 que estão dentro dos blocos (evita conflito com o menu)
        const sanfonaTitulos = document.querySelectorAll('.blocos .item h3');

        sanfonaTitulos.forEach(titulo => {
            titulo.addEventListener('click', function() {
                const itemAtual = this.parentElement; // A div .item da sanfona
                
                // OPCIONAL: Fecha as outras sanfonas do MESMO bloco ao abrir uma
                // Se quiser que várias fiquem abertas ao mesmo tempo, apague este bloco "forEach"
                const irmaos = itemAtual.parentElement.querySelectorAll('.item');
                irmaos.forEach(irmao => {
                    if (irmao !== itemAtual) {
                        irmao.classList.remove('aberta');
                    }
                });
                // ------------------------------------------------------------------

                // Alterna a classe 'aberta' no item clicado
                itemAtual.classList.toggle('aberta');
            });
        });




        // Seleciona todos os elementos necessários
        const listaUF = document.querySelectorAll('.listUF ul li');
        const containerListUF = document.querySelector('.listUF'); // Elemento que vamos medir a altura
        const mapaInfos = document.querySelector('.mapaInfos');
        const infos = document.querySelectorAll('.mapaInfos .infos .info');
        const btnVoltar = document.querySelector('.voltarLista');

        // Lógica para clicar no item da lista (Estado/UF)
        listaUF.forEach((item, index) => {
            item.addEventListener('click', () => {
                
                // 1. Esconde todas as infos ativas anteriormente por segurança
                infos.forEach(info => info.classList.remove('mostrar'));
                
                if (mapaInfos) {
                    // 2. Mede a altura do container .listUF e aplica no .mapaInfos
                    if (containerListUF) {
                        const alturaDaLista = containerListUF.offsetHeight;
                        mapaInfos.style.height = alturaDaLista + 'px';
                    }

                    // 3. Mostra o container principal (mapaInfos)
                    mapaInfos.classList.add('mostrar');
                }
                
                // 4. Mostra a .info correspondente ao item clicado (mesmo index)
                if (infos[index]) {
                    infos[index].classList.add('mostrar');
                }
            });
        });

        // Lógica para o botão de voltar/fechar
        if (btnVoltar) {
            btnVoltar.addEventListener('click', (e) => {
                e.preventDefault();
                
                // 1. Inicia a animação de saída
                mapaInfos.classList.remove('mostrar');
                mapaInfos.classList.add('escondendo');
                
                // 2. Espera 500ms (tempo da animação) para então esconder de verdade
                setTimeout(() => {
                    mapaInfos.classList.remove('escondendo');
                    mapaInfos.style.height = ''; // Remove altura fixa
                    
                    // Esconde todas as infos
                    infos.forEach(info => info.classList.remove('mostrar'));
                }, 500); // 500ms é o tempo do seu @keyframes
            });
        }




    });
}



